import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { SelectionDialogs } from './../SelectionDialogs';
import { ILectioPlugin } from './Types';
import { LCDialogEditorUtils } from './LCEditorDialogUtils';

export class PluginLectioEmbed implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectioembed', {
			init: (editorOuter: CKEDITOR.editor) => {
				editorOuter.filter.allow('img[data-lc-type];img[data-lc-external];img[data-embed-xhtml]', 'lectioEmbed1');
				editorOuter.filter.allow('img[data-lc-external]', 'lectioEmbed2');
				editorOuter.addCommand('lectioEmbed', {
					exec: editor => {

						const editorConfig = LCDocumentEditorUtils.GetEditorConfig(editor);
						const resp = LCDialogEditorUtils.ShowSuitableContentPicker(
							editor,
							{ folderid: SelectionDialogs.InitialFolder.video },
							editorConfig);

						resp.promise.then(selection => {
							if (selection == null)
								return;

							LCDialogEditorUtils.ProcessNewHomeworkSelection(
								editorOuter, selection,
								editorConfig.handleHomeworkPickerSelection,
								resp.editorHadFocus);
						});
						return true;
					}
				});

				editorOuter.ui.addButton('lectioEmbedButton', {
					label: "Indsæt video fra Youtube eller Vimeo",
					command: 'lectioEmbed',
					icon: CKEDITOR.skin.icons.video!.path,
					toolbar: ''
				});
			}
		});
	}
}
